<template>
  <div class="display-flex flex-wrap typo-container">
    <div class="form-field typo-field" v-for="(oTypo, nKey) in typology" :key="nKey">
      <input type="checkbox" class="checkbox" :id="'typo_'+nKey" @change="vChangeTypo(oTypo, nKey)" />
      <label :for="'typo_'+nKey">{{oTypo.TMOTCLE}}</label>
    </div>
  </div>
</template>

<script>

import searchService from '@/modules/recherche/services/searchService'

export default {
  name: 'ProspectFormTypologie',
  data() {
    return {
      typology: Array()
    }
  },
  created() {
    searchService.getType().then(res => {
      this.typology = res.data.DS_O.OUT;      
    });
  },
  methods: {
    vChangeTypo(oTypo) {
      this.$store.dispatch('echantillon/SET_TYPOLOGY', oTypo);
    }
  }
};
</script>

<style scoped>
.typo-container {
  padding: 20px 20px 10px;
  border: solid 1px #e1e1e1;
  border-radius: 8px;
}
.typo-container .typo-field {
  min-width: 130px;
}
.display-flex {
  display: flex;
}
.flex-wrap {
  flex-wrap: wrap;
}
@media screen  and (max-width: 800px) {

  .typo-container .typo-field {
    flex-basis: 50%;
  }
}
</style>